import React from 'react';
import Icon from './Icon';

const EmailMelody = (props) => (
  <Icon viewBox="0 0 19 19" {...props}>
    <title>Email</title>
    <g id="New-UX" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="My-Account/Rewards" transform="translate(-704.000000, -609.000000)" stroke="#003953">
        <g id="email-icon" transform="translate(705.000000, 610.000000)">
          <path d="M15.8913043,12 L1.10869565,12 C0.49637997,12 0,11.525948 0,10.9411765 L0,1.05882353 C0,0.474051318 0.49637997,0 1.10869565,0 L15.8913043,0 C16.5036195,0 17,0.474051318 17,1.05882353 L17,10.9411765 C17,11.525948 16.5036195,12 15.8913043,12 Z" id="XMLID_1304_"/>
          <path d="M0,1.00211438 L7.6440277,6.8310661 C7.81864273,6.93694385 8.02558575,7 8.24887474,7 C8.47216373,7 8.67910675,6.93694385 8.853722,6.83106596 L8.85577096,6.83106596 L16.5,1" id="XMLID_1306_"/>
        </g>
      </g>
    </g>
  </Icon>
);

export default EmailMelody;
